var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "pagination" },
    [
      _c("el-pagination", {
        attrs: {
          layout: "prev, pager, next",
          total: _vm.total,
          "page-size": _vm.pageSize,
          "current-page": _vm.currentPage,
        },
        on: { "current-change": _vm.selectPage },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }